import { render, staticRenderFns } from "./BookingSaveHeader.vue?vue&type=template&id=31e05b27"
import script from "./BookingSaveHeader.vue?vue&type=script&lang=js"
export * from "./BookingSaveHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports